import React, { Component, PropTypes } from 'react';
import Gallery from 'react-photo-gallery';
import Lightbox from 'react-images';

const photos = [
  { src: '../assets/images/projects/B1.jpg', width: 4, height: 3 },
  { src: '../assets/images/projects/B2.jpg', width: 4, height: 3 },
  { src: '../assets/images/projects/B3.jpg', width: 4, height: 3 },
  { src: '../assets/images/projects/B4.jpg', width: 3, height: 4 },
  { src: '../assets/images/projects/B5.jpg', width: 3, height: 4 },
  { src: '../assets/images/projects/B6.jpg', width: 3, height: 4 },
  { src: '../assets/images/projects/B7.jpg', width: 4, height: 3 },
  { src: '../assets/images/projects/B8.jpg', width: 4, height: 3 },
  { src: '../assets/images/projects/B9.jpg', width: 4, height: 3 },
  { src: '../assets/images/projects/B10.jpg', width: 4, height: 3 },
  { src: '../assets/images/projects/B11.jpg', width: 4, height: 3 },
  { src: '../assets/images/projects/B12.jpg', width: 4, height: 3 },
  { src: '../assets/images/projects/B13.jpg', width: 3, height: 4 },
];

const photosSpital = [
  { src: '../assets/images/projects/spital/cuptor20191001.jpg', width: 4, height: 3 },
  { src: '../assets/images/projects/spital/cuptor220191001.jpg', width: 4, height: 3 },
  { src: '../assets/images/projects/spital/cuptor320191001.jpg', width: 4, height: 3 },
  { src: '../assets/images/projects/spital/frigider20191001.jpg', width: 4, height: 3 },
  { src: '../assets/images/projects/spital/frigider220191001.jpg', width: 4, height: 3 },
  { src: '../assets/images/projects/spital/garden20191001.jpg', width: 4, height: 3 },
  { src: '../assets/images/projects/spital/garden220191001.jpg', width: 4, height: 3 },
  { src: '../assets/images/projects/spital/garden320191001.jpg', width: 4, height: 3 },
  { src: '../assets/images/projects/spital/garden420191001.jpg', width: 4, height: 3 },
  { src: '../assets/images/projects/spital/garden520191001.jpg', width: 4, height: 3 },
  { src: '../assets/images/projects/spital/garden620191001.jpg', width: 4, height: 3 },
  { src: '../assets/images/projects/spital/gift20191001.jpg', width: 4, height: 3 },
  { src: '../assets/images/projects/spital/tv220191001.jpg', width: 4, height: 3 },
  { src: '../assets/images/projects/spital/tv320191001.jpg', width: 4, height: 3 },
  { src: '../assets/images/projects/spital/tv420191001.jpg', width: 4, height: 3 },
  { src: '../assets/images/projects/spital/tv520191001.jpg', width: 4, height: 3 },
  { src: '../assets/images/projects/spital/wash20191001.jpg', width: 4, height: 3 },
  { src: '../assets/images/projects/spital/wash320191001.jpg', width: 4, height: 3 },
  { src: '../assets/images/projects/spital/wash420191001.jpg', width: 4, height: 3 },
];

const photosd = [
  { src: '../assets/images/projects/D1.jpg', width: 4, height: 3 },
  { src: '../assets/images/projects/D2.jpg', width: 4, height: 3 },
  { src: '../assets/images/projects/D3.jpg', width: 3, height: 4 },
  { src: '../assets/images/projects/D4.jpg', width: 3, height: 4 },
  { src: '../assets/images/projects/D5.jpg', width: 4, height: 3 },
  { src: '../assets/images/projects/D6.jpg', width: 4, height: 3 },
  { src: '../assets/images/projects/D7.jpg', width: 3, height: 4 },
  { src: '../assets/images/projects/D8.jpg', width: 4, height: 3 },
  { src: '../assets/images/projects/D9.jpg', width: 4, height: 3 },
];

export default class Projects extends Component {
  constructor(props) {
    super(props)
    this.state = { currentImage: 0 };
    this.closeLightbox1 = this.closeLightbox1.bind(this);
    this.openLightbox1 = this.openLightbox1.bind(this);

    this.closeLightbox2 = this.closeLightbox2.bind(this);
    this.openLightbox2 = this.openLightbox2.bind(this);

    this.closeLightbox3 = this.closeLightbox3.bind(this);
    this.openLightbox3 = this.openLightbox3.bind(this);

    this.gotoNext = this.gotoNext.bind(this);
    this.gotoPrevious = this.gotoPrevious.bind(this);
  }

  openLightbox1(event, obj) {
    this.setState({
      currentImage: obj.index,
      lightboxIsOpen1: true,
    });
  }
  closeLightbox1() {
    this.setState({
      currentImage: 0,
      lightboxIsOpen1: false,
    });
  }

  openLightbox2(event, obj) {
    this.setState({
      currentImage: obj.index,
      lightboxIsOpen2: true,
    });
  }
  closeLightbox2() {
    this.setState({
      currentImage: 0,
      lightboxIsOpen2: false,
    });
  }


  openLightbox3(event, obj) {
    this.setState({
      currentImage: obj.index,
      lightboxIsOpen3: true,
    });
  }
  closeLightbox3() {
    this.setState({
      currentImage: 0,
      lightboxIsOpen3: false,
    });
  }

  gotoPrevious() {
    this.setState({
      currentImage: this.state.currentImage - 1,
    });
  }
  gotoNext() {
    this.setState({
      currentImage: this.state.currentImage + 1,
    });
  }

  render() {
    const { username } = this.props.params
    const { filter } = this.state


    return (
      <div className="col-sm-12">
        <h3>Proiecte finalizate</h3>

        <section className="category cc-articles">
          <div className="i" id="articles">
            <h3 className="category__title category__title--lozenge">
              <span>Proiect Spital - "Din dragoste pentru copii".</span></h3>
            <div className="item item--issue item--link">
              <p className="text-justify">"Dacă ți s-a dat un vis, ți se vor da și șanse să îl împlinești" - Irina Binder.
              Acesta e motto-ul nostru de foarte mult timp. <br />
              În urma cu nici doua luni am început sa visam frumos: ne doream sa facem ceva pt copilașii internați în secția de pediatrie 
              a Spitalului Orășenesc Huedin. Ne doream să începem un proiect de suflet "Din dragoste pentru copii". <br />
              Am mers la spital, am discutat cu d-na director, cu d-na doctor șef de secție și am stabilit nevoile. <br />
              Asociaţia Umanitară "Dreptul la viaţă"- Huedin a reușit! <br />
              Azi, toate saloanele secției de pediatrie sunt dotate cu frigidere noi, cu televizoare prinse în suport pe perete, DVD-playere.  <br />
              Bucătăria secției are de acum doua cuptoare cu microunde noi și mașina de spălat vase. În parculetul din fata spitalului, acum 
              se montează un complex de joaca frumos. <br />
              Garderoba spitalului a fost dotata cu 40 pijamale pt copii și 17 perechi de papucei de casă. <br />
              Azi, când acest vis este împlinit, suntem cu lacrimi în ochi de fericire și recunoștință. <br />
              Recunoștință și mulțumiri pt: <br />
              - S. C. XFINIUM Software S. R. L <br />
              - FLANCO ROMANIA <br />
              - AROBS <br />
              - S. C. SISTEME FEROVIARE ȘI TELECOMUNICAȚII INSTAL S. R. L. <br />
              Mulțumim, grup Craciunei și Craciunite! <br />
              #dindragostepentrucopii <br />
              </p>
            </div>
            </div>
            <div className="item item--issue item--link">
              <Gallery photos={photosSpital} onClick={this.openLightbox3} />
              <Lightbox
                images={photosSpital}
                onClose={this.closeLightbox3}
                onClickPrev={this.gotoPrevious}
                onClickNext={this.gotoNext}
                currentImage={this.state.currentImage}
                isOpen={this.state.lightboxIsOpen3}
              />
            </div>
            <div className="i" id="articles">
              <h3 className="category__title category__title--lozenge">
                <span>Proiect 1: Casuta Albastra – reabilitare si renovarea casa</span></h3>
              <div className="item item--issue item--link">
                <p className="text-justify">Cinci suflețele de copii, împreună cu părinții, locuiau într-o anexă a unei șuri. In urma lansării volumului 3 al romanului Fluturi de Irina Binder, cu sprijinul Libris.ro, am inceput reconstrucția și amenajarea acestei anexe și transformarea intr-o locuință cu două camere, mobilată si dotată cu toate cele necesare.  In acest demers ne-au mai sprijinit Beep Community, Donatorii de 10 și mulți alți donatori cu suflet bun.</p>
              </div>
            </div>
            <div className="item item--issue item--link embed-responsive embed-responsive-16by9">
              <iframe className="embed-responsive-item" width="854" height="480" src="https://www.youtube.com/embed/D65G8UEYXho" frameBorder="0" allowFullScreen></iframe>
              <p className="text-justify"></p>
            </div>

            <div className="i" id="articles">
              <h3 className="category__title category__title--lozenge">
                <span>Proiect 2: Casa Huedin 1 : - constructie casa de locuit</span></h3>
              <div className="item item--issue item--link">
                <p className="text-justify">O mămică cu doi copii, rămasă pe stradă, dormind uneori în scări de bloc, apoi într-o cameră insalubră, fără curent electric și sursă de apă, benefeciază de sprijinul nostru prin construirea unei căsuțe compusă din: cameră, bucătarie, baie. Tot cu sprijinul asociației această căsuță este mobilată și dotată cu toate cele necesare.</p>
              </div>
            </div>
            <div className="item item--issue item--link">
              <Gallery photos={photos} onClick={this.openLightbox1} />
              <Lightbox
                images={photos}
                onClose={this.closeLightbox1}
                onClickPrev={this.gotoPrevious}
                onClickNext={this.gotoNext}
                currentImage={this.state.currentImage}
                isOpen={this.state.lightboxIsOpen1}
              />
            </div>


            <div className="i" id="articles">
              <h3 className="category__title category__title--lozenge">
                <span>Proiect 3: Centrul de recuperare pentru copii cu nevoi special – amenajare si dotare</span></h3>
              <div className="item item--issue item--link">
                <p className="text-justify">C. Identificând nevoia unui centru de recuperare pentru copiii cu nevoi speciale din zona Huedin, am reușit amenajarea a două săli de terapie. Primăria și Consiliul Local Huedin ne-au oferit spațiul, noi ne-am ocupat de renovare, amenajare și dotare. Acest demers a început în urma lansarii cărții Insomnii de Irina Binder, tot cu sprijinul Libris.ro, Beep Community, precum și a altor donatori anonimi.</p>
              </div>
            </div>
            <div className="item item--issue item--link  embed-responsive embed-responsive-16by9">
              <iframe className="embed-responsive-item" width="854" height="480" src="https://www.youtube.com/embed/BFXUXF2O9YQ" frameBorder="0" allowFullScreen></iframe>
              <p className="text-justify"></p>
            </div>

            <div className="i" id="articles">
              <h3 className="category__title category__title--lozenge">
                <span>Proiect 4: Casa Huedin 2:  - constructie casa de locuit</span></h3>
              <div className="item item--issue item--link">
                <p className="text-justify">D. Construirea, amenajarea și dotarea cu cele necesare a unei alte căsuțe pentru un tătic ce își crește singur fetița de 8 ani, părăsită de mama de la 8 luni.</p>
              </div>
            </div>
            <div className="item item--issue item--link">
              <Gallery photos={photosd} onClick={this.openLightbox2} />
              <Lightbox
                images={photosd}
                onClose={this.closeLightbox2}
                onClickPrev={this.gotoPrevious}
                onClickNext={this.gotoNext}
                currentImage={this.state.currentImage}
                isOpen={this.state.lightboxIsOpen2}
              />
            </div>
        </section>
      </div>
        );
      }
}


// WEBPACK FOOTER //
// ./app/screens/Projects/projects.js